module.exports = __webpack_public_path__ + "img/dd@2x.85ad0a0f.png";